import React, { forwardRef } from "react";
import { Overlay } from "@radix-ui/react-dialog";
import { cn } from "@/utils/cn";

export const SheetOverlay = forwardRef<
    React.ElementRef<typeof Overlay>,
    React.ComponentPropsWithoutRef<typeof Overlay>
>(({ className, ...props }, ref) => {
    return (
        <Overlay
            ref={ref}
            data-slot="sheet-overlay"
            className={cn(
                "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
                className
            )}
            {...props}
        />
    );
});

SheetOverlay.displayName = "SheetOverlay";
